import "@src/components/postModal/post.css";
import "./compliance.css";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { PrivacyModule } from "@src/components/postModal/privacyModule";
import { AUDIENCE_TYPES, emptyAudience, hasAudience, summariseAudience } from "./complianceHelpers";

/**
 * Who a company-wide document goes to - the same audience model as Posts (and resolved by
 * the same server code), so "Site: X" means everyone allocated to site X, "Customer: Y"
 * everyone at Y's sites, and so on. Several audience types can be combined.
 */
export const AudiencePickerModal = ({ visible, value, onClose, onChange }) => {
    const [audience, setAudience] = useState(emptyAudience());
    const [active, setActive] = useState("site");

    useEffect(() => {
        if (visible) {
            setAudience({ ...emptyAudience(), ...(value || {}) });
            const firstUsed = AUDIENCE_TYPES.find((type) => value?.[type.key]?.includeAll || value?.[type.key]?.include?.length > 0);
            setActive(firstUsed?.key || "site");
        }
    }, [visible, value]);

    const activeType = AUDIENCE_TYPES.find((type) => type.key === active);
    const count = (key) => audience?.[key]?.includeAll ? "All" : audience?.[key]?.include?.length || 0;

    return (
        <Modal
            open={visible}
            width={820}
            closable={false}
            onCancel={onClose}
            footer={
                <div className="drawer-footer" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <button className={!hasAudience(audience) ? "disabled-btn drawer-filled-btn" : "drawer-filled-btn"} disabled={!hasAudience(audience)} onClick={() => { onChange(audience); onClose(); }}>
                        Done
                    </button>
                    <button className="drawer-outlined-btn" onClick={onClose}>Cancel</button>
                    <span className="cmp-hint" style={{ marginLeft: 8 }}>{summariseAudience(audience)}</span>
                </div>
            }
        >
            <div className="modal-header-title">
                <span style={{ letterSpacing: "0.2px" }}>Who must acknowledge this?</span>
                <span onClick={onClose}><FontAwesomeIcon className="close" icon={faClose} /></span>
            </div>
            <div className="modal-body" style={{ margin: "16px 0 0" }}>
                <div className="cmp-audience">
                    <div className="cmp-audience-types">
                        {AUDIENCE_TYPES.map((type) => (
                            <button key={type.key} type="button" className={`cmp-audience-type${active === type.key ? " active" : ""}`} onClick={() => setActive(type.key)}>
                                <span>{type.label}</span>
                                {count(type.key) ? <span className="cmp-audience-count">{count(type.key)}</span> : null}
                            </button>
                        ))}
                        <span className="cmp-hint" style={{ marginTop: 10 }}>
                            Sites, site groups and customers reach the officers allocated to those sites - including anyone allocated later.
                        </span>
                    </div>
                    <div className="cmp-audience-picker">
                        {activeType && (
                            <PrivacyModule key={activeType.visibility} visibility={activeType.visibility} privacy={audience} setPrivacy={setAudience} />
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
